import { json } from "@sveltejs/kit";
import { access, readFile } from "fs/promises";
import { join } from "path";
import { homedir } from "os";
import { v as validateMorphFile } from "../../../../../../chunks/morph.js";
const PANELS_DIR = join(homedir(), "morphbox", "panels");
const GET = async ({ params }) => {
  try {
    const { id } = params;
    if (!id) {
      return json({ error: "Panel ID is required" }, { status: 400 });
    }
    const morphPath = join(PANELS_DIR, `${id}.morph`);
    try {
      await access(morphPath);
      const morphContent = await readFile(morphPath, "utf-8");
      const morphData = JSON.parse(morphContent);
      if (validateMorphFile(morphData)) {
        return new Response(morphData.code, {
          headers: {
            "Content-Type": "text/html"
          }
        });
      } else {
        console.error("Invalid .morph file format");
      }
    } catch (morphError) {
    }
    const jsPath = join(PANELS_DIR, `${id}.js`);
    try {
      await access(jsPath);
      const jsContent = await readFile(jsPath, "utf-8");
      return new Response(jsContent, {
        headers: {
          "Content-Type": "text/html"
        }
      });
    } catch (jsError) {
    }
    const sveltePath = join(PANELS_DIR, `${id}.svelte`);
    try {
      await access(sveltePath);
      const svelteContent = await readFile(sveltePath, "utf-8");
      const contentMatch = svelteContent.match(/<!--\s*@morphbox-panel[\s\S]*?-->([\s\S]*)/);
      const content = contentMatch ? contentMatch[1].trim() : svelteContent;
      return new Response(content, {
        headers: {
          "Content-Type": "text/html"
        }
      });
    } catch (svelteError) {
      return json({ error: "Panel code not found" }, { status: 404 });
    }
  } catch (error) {
    console.error("Failed to get panel code:", error);
    return json({
      error: error instanceof Error ? error.message : "Failed to get panel code"
    }, { status: 500 });
  }
};
export {
  GET
};
